import { IconButton, TextField, TextFieldProps } from '@oy/ui';
import classNames from 'classnames';
import React from 'react';
import styles from './TableSearchInput.module.css';

type TableSearchInputProps = {
  onSearchIconClick?: () => void;
} & TextFieldProps;

export const TableSearchInput = ({
  onSearchIconClick,
  ...props
}: TableSearchInputProps) => {
  return (
    <TextField
      {...props}
      wrapperClassName={classNames(styles.searchWrap, props.wrapperClassName)}
      className={classNames(styles.input, props.className)}
      rightIcon={
        <IconButton
          iconName="search"
          className={styles.searchButton}
          buttonType={IconButton.Type.Square}
          onClick={onSearchIconClick}
        />
      }
    />
  );
};
